import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { CanActivate } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { StorageService } from './utils/services/storage.service';
import { CompanyProvider } from '@stuplay';
import { lastValueFrom, take } from 'rxjs';
import { UrlHelper } from './utils/helpers';
import { environment } from 'src/environments/environment';

@Injectable()
export class CompanyGuard implements CanActivate {
    public companyData: any = null;
    constructor(private router: Router, private companyProvider: CompanyProvider, private storageService: StorageService, private cookieService: CookieService) { }

    async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        // Fallback: si la cookie está bloqueada por Tracking Prevention, usar sessionStorage
        const companyId = this.cookieService.get('current_company') || sessionStorage.getItem('current_company') || '';

        if (companyId) {
            // Restaurar la cookie desde sessionStorage si estaba bloqueada
            if (!this.cookieService.check('current_company')) {
                this.cookieService.set('current_company', companyId, 10, '/', UrlHelper.getDomain(), false, 'Lax');
            }
            const success = await this.getCompanyData(companyId);
            if (!success || !this.companyData) {
                return false;
            }

            if (!route.params.companyId) {
                this.router.navigateByUrl(`${this.companyData.slug}${state.url}`);
            }

            return true;
        } else {
            if (route.params.companyId) {
                this.cookieService.set('current_company', route.params.companyId, 10, '/', UrlHelper.getDomain(), false, 'Lax');
                sessionStorage.setItem('current_company', route.params.companyId);
                window.location.reload();
            }
            return false;
        }
    }


    async getCompanyData(companyId?: string): Promise<boolean> {
        const id = companyId || this.cookieService.get('current_company');
        try {
            const data = await lastValueFrom(
                this.companyProvider.getCompany(id, { includes: 'roles,experience' })
            );
            this.companyData = data;
            this.storageService.set('company', data);
            return true;
        } catch (error) {
            return false;
        }
    }
}
